<template>
    <div id="aqt_content">
      <div class="line line1"></div>
      <p class="title title_size1">阿启泰项目案例</p>
      <p class="title title_size2">从阿启泰成立至今，阿启泰服务于众多行业并与许多第三方建立了重要的战略关系。</p>
      <img src="../../assets/img/case1.png" class="serve1"/>
      <div class="pc_case">
        <img src="../../assets/img/personal5.png" class="case1"/>
        <p class="title title_size1"  v-if="case_classify.length">{{case_classify[1].title}}項目案例</p>
        <ul class="case_items">
          <li class="case_item" v-for="(pc_case_item,index) in pcCaseArr" :key="index">
            <p class="item_title" >{{pc_case_item.title}}</p>
            <p class="item">{{pc_case_item.belong}}</p>
          </li >
        </ul>
      </div>
      <div class="pc_case">
        <img src="../../assets/img/personal5.png" class="case1"/>
        <p class="title title_size1" v-if="case_classify.length">{{case_classify[0].title}}項目案例</p>
        <ul class="case_items">
          <li class="case_item" v-for="(move_case_item,index) in moveCaseArr" :key="index">
            <p class="item_title">{{move_case_item.title}}</p>
            <p class="item">{{move_case_item.belong}}</p>
          </li >
        </ul>
      </div>
    </div>

</template>

<script>
  import Vue from 'vue';
  import axios from 'axios'
  Vue.prototype.$http=axios
    export default {
      data(){
        return {
          pcCaseArr:[],
          moveCaseArr:[],
          case_classify:[]
        }
      },
      methods:{
        getCase(id){
          const that=this;
          let url
          url = "http://admin.aqitai.com/Home/Index/ArticleList?cate_id="+id;
          if(id == "9" ){
            axios.get(url).then( data => {
              that.pcCaseArr=data.data.data
            }).catch(error=>{
              alert('当前网络不佳...')
            });
          }else if(id=='12'){
            axios.get(url).then( data => {
              that.moveCaseArr=data.data.data
            }).catch(error=>{
              alert('当前网络不佳...')
            });
          }
        }
      },
      mounted(){
        const that=this;
        that.getCase(9);
        that.getCase(12);
        var url = "http://admin.aqitai.com/Home/Index/CateList?type=2";
        axios.get(url).then( data => {
          that.case_classify=data.data.data;
        }).catch(error=>{
          alert('当前网络不佳...')
        });
      }
    }
</script>

<style scoped lang="less">
  #aqt_content{
    padding-top:4rem;
    .line{
      margin: 0 auto;
      width: 10%;
      height: 0.1rem;
      text-align: center;
      margin-top: 2rem;
      margin-bottom: 1.5rem;
    }
    .line1{
      background-color: #F5A623;
    }
    .title{
      margin-left: 0.5rem;
      margin-right: 0.5rem;
      text-align: center;
      letter-spacing: 0.1rem;
    }
    .title_size1{
      font-size: 1.2rem;
      color: #F4FAFF;
    }
    .title_size2{
      font-size: 1rem;
      color: #D3DFFF;
      line-height: 1.5rem;
      marign-top: 1.5rem;
      margin-top: 1rem;
      text-align:center;
    }
    .serve1{
      width: 60%;
      margin-left: 20%;
      margin-top: 2rem;
    }
    .pc_case{
      position:relative;
      margin-top:3rem;
      .case1{
        width: 1rem;
        position: absolute;
        top: 0.4%;
        left: 22%;
      }
      .case_items{

        overflow: hidden;
        width:100%;
        heihgt:auto;
        padding-top:3rem;


        .case_item{
          width:100%;
          height:3rem;
          text-indent:1rem;
          line-height:1.4rem;
          margin-bottom:0.5rem;
          .item_title{
            font-size:0.9rem;
            color:#D3DFFF;
            letter-spacing:0.1rem;
          }
          .item{
            font-size:0.7rem;
            color:#D3DFFF;
            letter-spacing:0.2rem;
          }
        }
      }
    }

  }
</style>
